/* 
 * Export component file to be used on project
*/

import ModalMenu from './ModalMenu.js';
export default ModalMenu;
